/* eslint-disable */
// frontendGE/material-dashboard-react-main/src/utils/personOptionalFields.js

const OPTIONAL_PERSON_FIELDS = ["Contact", "Account", "Address"];

export function normalizeOptionalText(value) {
  if (value === undefined || value === null) return null;

  const normalized = String(value).trim();
  return normalized === "" ? null : normalized;
}

export function normalizePersonOptionalFieldsForPayload(person = {}) {
  const payload = { ...person };

  OPTIONAL_PERSON_FIELDS.forEach((field) => {
    payload[field] = normalizeOptionalText(person[field]);
  });

  return payload;
}

export function displayOptionalPersonField(value) {
  const normalized = normalizeOptionalText(value);
  return normalized ?? "Sin completar";
}

export function getPersonApiErrorMessage(error, fallback = "No se pudo guardar la persona.") {
  const code = error?.response?.data?.code || error?.code;

  if (code === "PERSON_CONTACT_DUPLICATE") {
    return "Ya existe una persona con ese contacto.";
  }

  if (code === "PERSON_ACCOUNT_DUPLICATE") {
    return "Ya existe una persona con esa cuenta.";
  }

  return error?.response?.data?.error || error?.message || fallback;
}
